document.addEventListener("DOMContentLoaded", function () {
  document.querySelectorAll(".custom-language-switcher a").forEach((button) => {
    button.addEventListener("click", function (event) {
      // Disable custom button logic on mobile
      if (window.innerWidth <= 749) return;

      event.preventDefault();

      const lang = this.dataset.lang;
      const eaSelector = document.querySelector("#eaAtLanguages");

      if (!eaSelector) return;

      eaSelector.value = lang;

      eaSelector.dispatchEvent(new Event("input", { bubbles: true }));
      eaSelector.dispatchEvent(new Event("change", { bubbles: true }));
    });
  });
});

document.addEventListener("DOMContentLoaded", function () {
  const labels = {
    "": "Choose language",
    disable: "🇬🇧 EN",
    lv: "🇱🇻 LV",
    lt: "🇱🇹 LT",
    et: "🇪🇪 EE",
    fi: "🇫🇮 FI",
    pl: "🇵🇱 PL",
  };

  function renameEaOptions() {
    const eaSelector = document.querySelector("#eaAtLanguages");

    if (!eaSelector) return false;

    [...eaSelector.options].forEach((option) => {
      if (labels[option.value] !== undefined) {
        option.textContent = labels[option.value];
      }
    });

    return true;
  }

  if (renameEaOptions()) return;

  const observer = new MutationObserver(() => {
    if (renameEaOptions()) {
      observer.disconnect();
    }
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true,
  });
});